export const FETCH_WIDGETS_PENDING = "FETCH_WIDGETS_PENDING";
export const FETCH_WIDGETS_REJECTED = "FETCH_WIDGETS_REJECTED";
export const FETCH_WIDGETS_FULFILLED = "FETCH_WIDGETS_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/widgets.js